import React, { useRef, useEffect } from 'react';
import cn from 'classnames';
import style from './home-hero.mod.scss';
import Logo from '../logo/logo';
import Text from '../text/text';
import Button from '../button/button';
import Heading from '../heading/heading';
import Phone from '../../images/phone.svg';

// Define a new constant for the SVG

const HomeHero = ({text = false, heading = false}) => {

  const classes = cn(style.hero, {
    // [style[`hero--smaller`]]: smaller,
  });

  return (
    <div className={classes} id={"about"}>
      <div className={style.hero__content}>
        <div className={style.hero__content__inner}>    
          <Heading tag={1} text={heading} size={"display"} typing />
        </div>
        <div className={style.hero__content__inner}>
          <Text html={text} size={"lg"} />
        </div>
        <div className={style.hero__content__inner}>
          <Button text="Contact us" to={"#contact"}/>
        </div>
      </div>
      <div className={style.hero__animation}>
        <AnimationSVG />
      </div>
    </div>
  );
};

export default HomeHero;


const AnimationSVG = () => (
  <div className={style.hero__animation__svg}>
      <img src={Phone} alt="hero animation" />
  </div>
);
